import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as acessos from '../../../../../acessos.const.util';
import { acessoPermitido } from '../../../../../acessos.seguranca';
import {
  etapasEnum,
  statusEtapasEnum,
  tipoMedicoEnum
} from '@common/util/defaultValues';
import ModalEditarMedico from '../ModalEditar';

function BtnEditarRevisor ({ medicos, medicoSelecionado, etapa , getStatusEtapa, className }) {
  const usuario = useSelector(state => state.usuario);
  const editor = useSelector(state => state.editor);
  const [modal, setModal] = useState(false);
  const [medicoSelecionadoModal, setMedicoSelecionadoModal] = useState({});

  useEffect(() => {
    setMedicoSelecionadoModal(medicoSelecionado);
  }, [medicoSelecionado]);

  const toggle = () => setModal(!modal);  

  return (
    <div className={className}>
      {acessoPermitido(usuario, acessos.MedicoDesignado) && (
        <ModalEditarMedico
          toggle={toggle}
          setMedicoSelecionadoModal={setMedicoSelecionadoModal}
          medicoSelecionadoModal={medicoSelecionadoModal}
          tipoMedico={tipoMedicoEnum.REVISOR}
          modal={modal}
          etapa={etapa}
          medicos={medicos}
        />
      )}
      {acessoPermitido(usuario, acessos.MedicoDesignado) &&
        acessoPermitido(usuario, acessos.AlterarMedicoExecutanteRevisor) &&
        ([
          statusEtapasEnum.NAO_REALIZADO,
          statusEtapasEnum.PENDENTE,
          statusEtapasEnum.REVISAO
        ].indexOf(getStatusEtapa()) > -1 ||
          etapa.etapa === etapasEnum.NOTAS ||
          ([
            statusEtapasEnum.NAO_REALIZADO,
            statusEtapasEnum.PENDENTE,
            statusEtapasEnum.REVISAO
          ].indexOf(getStatusEtapa()) > -1 &&
            !editor.medRevisor)) && (
          <i
            className='mv-basico-atualizar'
            style={{
              padding: '0 5px',
              fontSize: '17px'
            }}
            onClick={toggle}
            data-toggle='tooltip'
            title='Alterar médico revisor do exame'
          ></i>
        )}
    </div>
  );
}

export default BtnEditarRevisor;



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/Medico/BtnEditarRevisor/index.js